import request from '@/utils/request';

// 会员合卡
export function handleMergeCard(values) {
  return request('/manualOperation/mergeCard', {
    method: 'POST',
    data: values,
  });
}
